import { printStyles } from "./printStyle";
declare const html2pdf: any;
let count = 0;

export const ExportHtml = {
	downloadAsPdf: (fileName: string, html: string) => {
		let allStyles = document.getElementsByTagName("style");
		let styleHtml = "";
		const text = html.replace(/<(?:.|\n)*?>/gm, (match) => mutateHtml(match));
		count = 0;

		for (let i = 0; i < allStyles.length; i++) {
			styleHtml += `<style>${allStyles[i].innerHTML}</style>`;
		}

		let outputHtml = `
        <html lang="en">
            <head>
            ${styleHtml}
            </head>
            <body>
            ${text}
            </body>
        </html>`;
		
		// https://github.com/eKoopmans/html2pdf#options
		var options = {
			margin: 1,
			filename: `${fileName}.pdf`,
			image: { type: "jpeg", quality: 0.98 },
			html2canvas: { scale: 2, logging: false },
			jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
			pagebreak: { mode: "avoid-all" },
		};
		html2pdf().set(options).from(outputHtml).save();
	},

	print: (html: string, columns: number) => {
		const text = html.replace(/<(?:.|\n)*?>/gm, (match) => mutateHtml(match));
		count = 0;

		const columnStyle = columns === 1 ? "" : `style="columns:${columns};-moz-column-count: ${columns};-webkit-column-count:${columns}"`

		let outputHtml = `
        <html lang="en">
            <head>
			<style type="text/css">${printStyles}</style>           
			</head>
            <body style="background-color: #fff">
            <div class="print-page" ${columnStyle}>${text}</div>
            </body>
        </html>`;

		let win = window.open();
		if (win != null) {
			win.document.write(outputHtml);
			win.print();
			win.close();
		}
	},
};

function mutateHtml(match: string) {
	switch (match) {
		case "<blockquote>":
			return "<blockquote><em>";
		case "</blockquote>":
			return "</em></blockquote>";
		case "<slide>":
			count++;
			return `<span class="slide" count="${count}">`;
		case "</slide>":
			return "</span>";
		default:
			return match;
	}
}
